import { render, staticRenderFns } from "./detailResource.vue?vue&type=template&id=4d581d36&scoped=true"
import script from "./detailResource.vue?vue&type=script&lang=js"
export * from "./detailResource.vue?vue&type=script&lang=js"
import style0 from "./detailResource.vue?vue&type=style&index=0&id=4d581d36&prod&lang=less"
import style1 from "./detailResource.vue?vue&type=style&index=1&id=4d581d36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d581d36",
  null
  
)

export default component.exports